import { Divider } from "antd";

const Coagadex = () => {
  return (
    <>
      <div className="bg-[#f3f3f3] p-4 md:p-8 pt-4 rounded-md">
        <Divider />
        <p className="m-2 font-bold">
          Indications for COAGADEX
        </p>

        <p className="m-2">
          COAGADEX, a plasma-derived blood coagulation factor X concentrate, is indicated in adults and children (aged 12 years and above) with hereditary factor X deficiency for:
        </p>

        <ul className="list-disc pl-10">
          <li className="m-2">Routine prophylaxis to reduce the frequency of bleeding episodes</li>
          <li className="m-2">On-demand treatment and control of bleeding episodes</li>
          <li className="m-2">
            Perioperative management of bleeding in patients with mild and moderate hereditary Factor X deficiency
          </li>
        </ul>

        <p className="m-2 underline">
          Limitation of use
        </p>

        <p className="m-2">
          Perioperative management of bleeding in major surgery in patients with severe hereditary factor X deficiency has not been studied.
        </p>

        <p className="m-2 mt-6 font-bold">
          Important Safety Information
        </p>

        <p className="m-2">
          COAGADEX is contraindicated in patients with known hypersensitivity to any of the components of the product.
        </p>

        <p className="m-2">
          Allergic type hypersensitivity reactions, including anaphylaxis, are possible with COAGADEX. If symptoms occur, patients should discontinue use of the product immediately and contact their physician.
        </p>

        <p className="m-2">
          The formation of neutralizing antibodies (inhibitors) to factor X is a possible complication in the management of individuals with factor X deficiency. Carefully monitor patients taking COAGADEX for the development of inhibitors by appropriate clinical observations and laboratory tests.
        </p>

        <p className="m-2">
          COAGADEX is made from human plasma and may contain infectious agents, e.g. viruses, the variant Creutzfeldt-Jakob disease (vCJD) agent and, theoretically, the Creutzfeldt-Jakob disease (CJD) agent. No cases of transmission of viral diseases, vCJD or CJD, have been associated with the use of COAGADEX.
        </p>

        <p className="m-2">
          In clinical studies, the most common adverse reactions (frequency ≥5% of subjects) with COAGADEX were infusion site erythema, infusion site pain, fatigue and back pain.
        </p>

        <div>
          <p className="m-2">
            <b>
              Please see&nbsp;
              <a
                target="_blank"
                href="/Coagadex-Prescribing-Information.pdf"
                className="text-blue-500 hover:underline"
              >
                full Prescribing Information for Coagadex
              </a>
            </b>
          </p>
          <p className="m-2">
            <b>
              You are encouraged to report negative side effects of
              prescription drugs to the FDA. Visit&nbsp;
              <a
                target="_blank"
                href="http://www.fda.gov/medwatch"
                className="text-blue-500 hover:underline"
              >
                www.fda.gov/medwatch
              </a>
              &nbsp;or call 1-800-FDA-1088.
            </b>
          </p>
        </div>

        <Divider/>

        <div>
          <p className="m-2">
            <a
              target="_blank"
              href="http://www.coagadex.com/"
              className="text-blue-500 hover:underline"
            >
              Coagadex®
            </a>&nbsp;is a registered trademark of&nbsp;
            <a
              target="_blank"
              href="https://www.kedrion.us/"
              className="text-blue-500 hover:underline"
            >
              Kedrion Biopharma Inc.
            </a>
          </p>
          <p className="m-2">
            Coagadex is manufactured by Bio Products Laboratory U.S.A., Inc. and distributed by&nbsp;
            <a
              target="_blank"
              href="https://www.kedrion.us/"
              className="text-blue-500 hover:underline"
            >
              Kedrion Biopharma Inc.
            </a>
          </p>
          <p className="m-2">US/X/0319/0016</p>
        </div>
      </div>
    </>
  );
};

export default Coagadex;
